import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import { injectIntl, defineMessages } from 'react-intl';

import { getAllArticulationAgreements } from '../utils';
import TextDataPod from '../../../components/TextDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.transfer.artic-agr.title',
    defaultMessage: 'Articulation Agreements',
  },
  tooltip: {
    id: 'hubs.transfer.artic-agr.tooltip',
    defaultMessage: `An articulation agreement is a written contract between two or more colleges. It spells out exactly what is required to transfer from one college to the other. The agreement often includes detailed information on what credits will transfer, course requirements, if there's guaranteed admission and how that works, and if there are scholarships available. Articulation agreements are intended to make the transfer process smoother and clearer for students transferring between the colleges that have these agreements.`,
  },
  tooltipHeader: {
    id: 'hubs.transfer.artic-agr.tooltip-header',
    defaultMessage: `What's an Articulation Agreement?`,
  },
  linkText: {
    id: 'hubs.transfer.artic-agr.link-text',
    defaultMessage: `Learn more about credit transfer arrangements`,
  },
});

const ArticulationAgreements = ({ intl, transferAdmissions }) => {
  const lastUpdated = get(transferAdmissions, 'lastUpdated.value');
  const articulationAgreements = getAllArticulationAgreements(
    get(transferAdmissions, 'articulationAgreementsSystem.value', []),
    get(transferAdmissions, 'articulationAgreements.value', []),
  );
  const tooltip = intl.formatMessage(messages.tooltip);

  return articulationAgreements && articulationAgreements.length ? (
    <TextDataPod
      tooltip={tooltip}
      footer={lastUpdated}
      header={intl.formatMessage(messages.title)}
      tooltipHeader={intl.formatMessage(messages.tooltipHeader)}
      content={{
        value: '✓',
        linkUrl: 'Transfer#transferring-credits',
        linkText: intl.formatMessage(messages.linkText),
      }}
    />
  ) : null;
};
ArticulationAgreements.propTypes = {
  intl: PropTypes.object,
  transferAdmissions: PropTypes.object,
};

export default injectIntl(ArticulationAgreements);
